import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'
import {useContext} from 'react'
import {AlertBox} from '../../../../../_metronic/layout/components/alert-message'
import { PlanFeaturesListHeader } from './components/header/PlanFeaturesListHeader'
import { PlanFeaturesTable } from './table/PlanFeaturesTable'
import { KTCard } from '../../../../../_metronic/helpers'

const PlanFeaturesList = () => {
  const {itemIdForUpdate} = useListView()
  const {show, message, type} = useContext(AlertContext)
  return (
    <>
      <KTCard>
        {show && <AlertBox type={type === true ? 'success' : 'error'} message={message} />}
        <PlanFeaturesListHeader />
        <PlanFeaturesTable />
      </KTCard>
    </>
  )
}

const PlanFeaturesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PlanFeaturesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PlanFeaturesListWrapper}
